import { createSelector } from 'reselect';
import { getState } from '../rootSelector';
export const getSelectedPassengerId = createSelector(getState, state => state.selectedPassengerId);
